import { Col, Form, Row } from 'antd';
import moment from 'moment';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { USER_PREFERENCES } from '../../../../../../contants/common';
import useUserPreference from '../../../../../../redux/hooks/useUserPreference';
import { convertDateESTToUTCToUserLocal, formateWithMoment } from '../../../../../../utilz/dates';
import { routeFileSelector } from '../../../../../../utilz/i18n';
import FormInput from '../../../../../components/Inputs/FormInput';
import HiddenFormInput from '../../../../../components/Inputs/HiddenFormInput';
import FormLabel from '../../../../../components/Labels/FormLabel';
import SecondaryLabel from '../../../../../components/Labels/SecondaryLabel';
import ShipmentCreatedBySelector from '../../../../../components/Selectors/ShipmentCreatedBySelector';

const TMSQuoteDetailsForm = () => {
  const { user, selectedCompany } = useSelector((state) => state.auth);
  const { createShipmentQuote } = useSelector((state) => state.shipment);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const [form] = Form.useForm();
  const createdOn = convertDateESTToUTCToUserLocal(Form.useWatch('createdOn', form));
  const modifiedOn = Form.useWatch('modifiedOn', form);

  useEffect(() => {
    if (selectedCompany?.companyId) {
      form.setFieldValue('customerKey', selectedCompany?.companyId);
    }
  }, [selectedCompany]);

  useEffect(() => {
    if (createShipmentQuote?.success && createShipmentQuote?.data?.quoteNo) {
      form.setFieldValue('quoteNo', createShipmentQuote?.data?.quoteNo);
    }
  }, [createShipmentQuote]);

  const userDateFormat = useUserPreference(USER_PREFERENCES.DEFAULT_DATE_FORMAT);

  return (
    <Form
      form={form}
      name="quoteDetailsForm"
      initialValues={{
        createdBy: user?.data?.id,
        createdOn: moment(new Date()),
        shipmentNumber: '',
        shipmentKey: 0,
        shipmentStatus: null,
        customerKey: 0,
      }}
    >
      <Row gutter={30}>
        <Col sm={6}>
          <Row gutter={15}>
            <Col sm={12}>
              <FormInput label={t('translation:default.fields.quoteNo')} editMode={false} margin="m-0" name="quoteNo" />
            </Col>
            <Col sm={12}>
              <FormInput
                name="projectNo"
                label={t('translation:getQuote.quoteDetails.projectNo.label')}
                editMode
                margin="m-0"
              />
            </Col>
          </Row>
        </Col>
        <Col sm={6}>
          <Row gutter={15}>
            <Col sm={6}>
              <FormInput
                name="rateShopCost"
                label={t('translation:getQuote.quoteDetails.quoteCost.label')}
                editMode={false}
                margin="m-0"
              />
            </Col>
            <Col sm={4}>
              <FormInput
                name="currencyCode"
                label={t('translation:default.fields.currency.label')}
                editMode={false}
                margin="m-0"
              />
            </Col>
            <Col sm={14}>
              <FormInput
                label={t('translation:getQuote.quoteDetails.quoteTransportationProvider.label')}
                editMode={false}
                margin="m-0"
              />
            </Col>
          </Row>
        </Col>
        <Col sm={6}>
          <Row gutter={15}>
            <Col sm={12}>
              <ShipmentCreatedBySelector
                name="createdBy"
                label={t('translation:getQuote.quoteDetails.createdBy.label')}
                editMode={false}
                margin="m-0"
              />
            </Col>
            <Col sm={12}>
              <FormLabel>{t('translation:default.fields.createdOn.title')}</FormLabel>
              <div>
                <SecondaryLabel className="f-14 fw-600 text-dark">{`${formateWithMoment(
                  createdOn,
                  userDateFormat,
                )} | ${formateWithMoment(createdOn, 'hh:mm:ss A')}`}</SecondaryLabel>
              </div>
            </Col>
          </Row>
        </Col>
        <Col sm={6}>
          <Row gutter={15}>
            <Col sm={12}>
              <FormInput
                name="modifiedBy"
                label={t('translation:default.fields.modifiedBy')}
                editMode={false}
                margin="m-0"
              />
            </Col>
            <Col sm={12}>
              <FormLabel>{t('translation:default.fields.modifiedOn')}</FormLabel>
              {modifiedOn && (
                <div>
                  <SecondaryLabel className="f-14 fw-600 text-dark">{`${formateWithMoment(
                    modifiedOn,
                  )} | ${formateWithMoment(modifiedOn, 'hh:mm:ss A')}`}</SecondaryLabel>
                </div>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <HiddenFormInput name="createdOn" />
      <HiddenFormInput name="modifiedOn" />
      <HiddenFormInput name="shipmentNumber" />
      <HiddenFormInput name="shipmentKey" />
      <HiddenFormInput name="shipmentStatus" />
      <HiddenFormInput name="customerKey" />
    </Form>
  );
};

export default TMSQuoteDetailsForm;
